export default function useArticleUnnamedPersonsOptions() {
	return [
		{ key: "05", value: "05", text: "Synthesized voice – male" },
		{ key: "06", value: "06", text: "Synthesized voice – female" },
		{ key: "07", value: "07", text: "Synthesized voice – unspecified" },
		{ key: "08", value: "08", text: "Synthesized voice – based on real voice actor" },
		{ key: "09", value: "09", text: "AI (Artificial intelligence)" },
	];
}
